<template>
  <div>
      <el-pagination
      @size-change="handleSizeChange"
      background
      @current-change="handleCurrentChange"
      :current-page.sync="page"
      :page-sizes="pagesizeList"
      :page-size="pagesize"
      :layout="unsize?unsize:' prev, pager, next, ->, sizes, total'"
      :total="total">
    </el-pagination>
  </div>
</template>

<script>

export default {
  name: 'pagination',
  props:['pagesizeList','pagesize','total','page','unsize','color','name'],
  methods:{
      handleSizeChange(size){
          console.log(size);
          // size改变回到第一页
          let c=this.$parent
          // c.paginationChange
          // 查找最上层的paginationChange函数
          while(!c.paginationChange){
              c=c.$parent
          }
          c.paginationChange(size,1,this.name);
      },
      handleCurrentChange(page){
          console.log(page);
          // console.log(this.$parent.$parent.$parent.$parent.paginationChange)
          let c=this.$parent
          // c.paginationChange
          while(!c.paginationChange){
              c=c.$parent
          }
          // if(){
            c.paginationChange(-1,page,this.name)
          // }else{
          // }
          // this.$parent.paginationChange(-1,page)

      }
  },
  mounted(){
    if(this.color){
      var pageColor=document.querySelector('.el-pagination')
      pageColor.style.backgroundColor=this.color
    }
  }
}
</script>

<style scoped>
    .el-pagination{
        padding-top: 15px;
        text-align:center;
        background-color: #E9EEF3;
    }
    .el-select .el-input__inner{
      background-color: #E9EEF3!important;
    }
</style>



// WEBPACK FOOTER //
// src/components/pagination/pagination.vue